<template>
  <div v-if="isLoading" class="app-loader" aria-live="polite" aria-busy="true">
    <div class="app-loader__content">
      <div class="spinner-border text-warning" role="status"></div>
      <div class="mt-3 fw-semibold">{{ state.loadingMessage }}</div>
    </div>
  </div>
</template>

<script>
import state from "@/state/app";

export default {
  name: "AppLoader",
  data() {
    return { state };
  },
  computed: {
    isLoading() {
      return this.state.pendingRequests > 0;
    },
  },
};
</script>

<style scoped>
.app-loader {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(2px);
}

.app-loader__content {
  min-width: 180px;
  padding: 24px;
  text-align: center;
  color: #101828;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(16, 24, 40, 0.18);
}
</style>
